// extracted by mini-css-extract-plugin
module.exports = {"container":"jgp-1llq7","icon":"jgp-2ZTVG","label":"jgp-o9KU3"};